/** @format */

import { ParentGroupSummary } from "@question-bank/shared";
import "./AppQuestionCard.css";
import { formatSeason, toStringArray } from "../utils/helpers";

interface QuestionCardProps {
	question: ParentGroupSummary;
	onClick?: () => void;
}

export const AppQuestionCard = ({ question, onClick }: QuestionCardProps) => {
	const formatSeries = (series?: { season?: unknown; year?: number }) => {
		if (!series) {
			return null;
		}
		return [formatSeason(series.season), series.year].filter(Boolean).join(" ") || null;
	};

	const subjectLabel = toStringArray(question.subject).join(", ") || "Unknown";
	const title = `${subjectLabel} (Q: ${question.questionNumber || "?"})  `;

	return (
		<div className="question-card" onClick={onClick}>
			<div className="question-header">
				<span className="question-title">{title}</span>
				<div className="question-meta">
					{(question.qualification.title ?? question.qualification.code) && (
						<span className="badge badge-level">{question.qualification.title ?? question.qualification.code}</span>
					)}
					{question.tier && <span className="badge badge-tier">{question.tier.title ?? question.tier.code}</span>}
				</div>
			</div>

			<div className="question-footer">
				<div className="question-info">
					{typeof question.totalMarks === "number" && <span className="marks">{question.totalMarks} marks</span>}
					{question.paperCode && <span className="paper-code">{question.paperCode}</span>}
					{question.series && <span className="series">{formatSeries(question.series)}</span>}
					{question.childCount > 1 && <span className="parts">{question.childCount} parts</span>}
				</div>
			</div>
		</div>
	);
};
